import app_img from '@/public/article/App.webp';
import managment_img from '@/public/article/Customer management.webp';
import invoicing from '@/public/article/Invoice.webp';
import orders_img from '@/public/article/Orders.webp';
import article1 from '@/public/article/picture.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import main_bg from '@/public/industries/electrician/Electrician-bg.webp';
import image4 from '@/public/industries/hvac/Reporting-and-analytics.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title:
      'What are the benefits of an all-in-one operational software for electrical contractors?',
    text: 'All-in-one operational software centralizes tasks, improving coordination and efficiency. Electrical job management software streamlines project tracking, customer interactions, and financial processes, which can enhance productivity and profitability.',
  },
  {
    title: 'Does your electrician service software have a mobile app?',
    text: 'Our software for electrician includes a comprehensive electrical contractor app, facilitating on-the-go management for electricians to handle scheduling, client data, and job updates from their mobile devices.',
  },
  {
    title: 'Can technicians use electrical contracting software on the job?',
    text: 'Technicians can leverage our electrical contracting software on job sites for immediate access to work orders, client information, and to update job statuses, ensuring efficient workflow and client communication.',
  },
];

const testimonals = [
  {
    text: `Orcatec's software revolutionized how we manage our electrician fleet. Even if we doubled our team, their system would effortlessly keep us organized.`,
    name: 'Michael T.,',
    position: 'QuickVolt Electric',
  },
  {
    text: `The scheduling and CRM features of Orcatec have been game-changers for our service delivery. It's as if the software was custom-made for us.`,
    name: 'Samantha L.,',
    position: 'BrightSpark Electrical',
  },
  {
    text: 'From invoicing to dispatch, Orcatec has everything covered. Our efficiency has soared, and our customers have never been happier.',
    name: 'Luis G.,',
    position: 'HighWire Electrical Services',
  },
  {
    text: `Orcatec's software revolutionized how we manage our electrician fleet. Even if we doubled our team, their system would effortlessly keep us organized.`,
    name: 'Michael T.,',
    position: 'QuickVolt Electric',
  },
  {
    text: `The scheduling and CRM features of Orcatec have been game-changers for our service delivery. It's as if the software was custom-made for us.`,
    name: 'Samantha L.,',
    position: 'BrightSpark Electrical',
  },
  {
    text: 'From invoicing to dispatch, Orcatec has everything covered. Our efficiency has soared, and our customers have never been happier.',
    name: 'Luis G.,',
    position: 'HighWire Electrical Services',
  },
];

const industries = {
  title: 'Our industries',
  description: `Orcatec is a flexible platform that is suitable for companies providing field services. We designed our field service management software to meet the diverse needs.`,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES_HOME_CLEANING,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES_HANDYMAN,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES_CONSTRUCTION,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Electrician Service Software Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Job Scheduling',
      },
      href: '#',
      tag: 'Job Scheduling',
      title: 'Optimize Field Operations',
      text: `Maximize your team's productivity and efficiency with our advanced job scheduling feature, specifically designed for the electrical industry. This tool ensures you allocate your skilled electricians and resources optimally, leading to improved time management, minimized scheduling conflicts, and heightened customer satisfaction. Promise and deliver on your timelines, enhancing your reliability and quality service reputation.`,
      list: [
        { text: 'Efficient job planning and scheduling.' },
        { text: 'Minimization of scheduling overlaps.' },
        { text: 'Optimal resource allocation for various job types.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer management',
      },
      href: '#',
      tag: 'Customer management',
      title: 'Build Lasting Relationships',
      text: `Elevate your service with our CRM tools, designed with electricians in mind. Gain a comprehensive understanding of your client's preferences, service history, and interactions. This insight is pivotal for building stronger relationships, encouraging repeat business, and tailoring your services to meet each customer's unique needs.`,
      list: [
        { text: 'Detailed tracking of customer interactions and inquiries.' },
        { text: 'Management of customer preferences and individual needs.' },
        { text: 'Comprehensive service history recording for each client.' },
      ],
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: invoicing,
        alt: 'Invoicing and Billing ',
      },
      href: '#',
      tag: 'Invoicing and payments',
      title: 'Invoicing and Billing',
      text: 'Streamline your financial transactions with our invoicing and billing feature, specifically tailored to fit the diverse billing needs of electricians. Automate your invoicing process, minimize errors, and ensure timely payments. This not only improves your cash flow but also allows you to focus more on delivering top-notch electrical services rather than managing paperwork.',

      list: [
        { text: 'Automated invoicing and billing process.' },
        { text: 'Reduction of billing errors and discrepancies.' },
        { text: 'Easy tracking and management of financial transactions.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: image4.src,
        alt: 'Reporting and analytics',
      },
      href: '#',
      tag: 'Reporting and analytics',
      title: 'Make Decision by Data-Driven',
      text: `Unlock the full potential of your electrical business with our reporting and analytics tools. Gain valuable insights into your operations, from performance metrics to customer engagement trends. Use this data to make informed decisions that drive growth, optimize operations, and ensure you're meeting the evolving needs of your clients.`,
      list: [
        { text: 'Insightful business analytics and customizable reports.' },
        { text: 'Monitoring of performance metrics and customer engagement.' },
        { text: 'Data analysis tools for strategic decision-making.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: orders_img,
        alt: 'Real-time Updates and Mobile Access',
      },
      href: '#',
      tag: 'Equipment orders',
      title: 'Real-time Updates and Mobile Access',
      text: `Stay informed and agile with real-time updates and mobile access to job information. This feature ensures that your electricians can access schedules, job details, and updates on the go, allowing for swift responses to any changes. Enhance your team's efficiency and customer satisfaction by being proactive and well-informed at all times.`,
      list: [
        { text: 'Provision of real-time updates on job status and changes.' },
        {
          text: 'Mobile access to job information and schedules.',
        },
        { text: 'Immediate communication and collaboration tools.' },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Electrical Сontractor Software',
  title: {
    first_part: 'Optimize Your Workflow with Our',
    second_part: 'Comprehensive Tool!',
  },
  description:
    'Experience seamless job scheduling, quick invoicing, and efficient project management to boost service delivery. Increase productivity, gain more clients, and skyrocket your profits — all in a user-friendly platform. Start your journey toward operational excellence today!',
  info: [
    { title: '40 hours', description: 'Reduced Monthly Paperwork' },
    { title: '35%', description: 'Workforce Productivity' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1.src,
    alt: 'What Is Electrical Business Software?',
  },
  title: 'What Is Electrical Business Software?',
  description: `The electrician business software from Orcatec is designed to enhance the functionality of electrical contracting businesses. Our tools are tailored to meet the unique needs and challenges faced by professionals in the electrical industry, with a focus on:`,
  item: [
    {
      title: 'Increased Productivity',
      description:
        'Automate routine tasks such as scheduling, dispatching, and invoicing so you can focus on more important matters.',
    },
    {
      title: 'Improved Customer Service',
      description:
        'Ensure quick communication with customers, timely invoicing, and quality control of services.',
    },
    {
      title: 'Easy Control of All Processes',
      description:
        'Have quick access to all your business information in one place, from any device.',
    },
    {
      title: 'Inventory Management',
      description:
        'Gain real-time visibility into your inventory levels and optimize stock control.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Electrical Contractors Choosing Orcatec?',
  },
  title: 'Why Electrical Contractors Choosing Orcatec?',
  description: `Electrical contractors are increasingly choosing Orcatec for several compelling reasons, making it a preferred software solution in their industry:`,
  item: [
    {
      title: '',
      description:
        'Orcatec offers a complimentary initial offering that is ideal for small or starting businesses, providing essential features without any upfront costs.',
    },
    {
      title: '',
      description:
        'Contractors enjoy customized solutions as they can selectively choose and pay only for the features they need, enabling cost-effective scalability.',
    },
    {
      title: '',
      description: `The software's capacity for easy customization allows for a personalized experience tailored to match specific business workflows and requirements.`,
    },
    {
      title: '',
      description: `Orcatec is universally accessible on various devices and operating systems, including iOS and Android, ensuring seamless connectivity whether in the field or office.`,
    },

    {
      title: '',
      description: `Orcatec integrates multiple business management aspects, fostering operational excellence by reducing administrative workload and boosting overall productivity.`,
    },
    {
      title: '',
      description: `The system's efficient job tracking and communication tools aid in forging stronger client bonds by maintaining and enhancing customer relationships.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Stay ahead in the electrician job management software field with our concise articles: key insights, industry trends, and practical strategies tailored for the electrical industry.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Let us guide you to experience in electrical contractor software! Orcatec team is here to help you. Our experts are ready to amplify your operational efficiency.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
